export enum MatchEventStatus {
  POSTING = 2,
  PUBLISHED = 3,
  PATCHING = 4,
  DELETING = 5,
  ERROR = 6,
  UPDATED = 7,
  DELETE_ERROR = 8,
  RE_POSTING = 9,
}
